import { render, staticRenderFns } from "./platdutyPaid.vue?vue&type=template&id=58bb062a&scoped=true&"
import script from "./platdutyPaid.vue?vue&type=script&lang=js&"
export * from "./platdutyPaid.vue?vue&type=script&lang=js&"
import style0 from "./platdutyPaid.vue?vue&type=style&index=0&id=58bb062a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb062a",
  null
  
)

export default component.exports